import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getMyProfile } from "../../redux-toolkit/slices/authSlice";
import { RootState, useAppDispatch } from "../../redux-toolkit/store/store";
import { useNavigate } from "react-router-dom";
import {
  getMetaChatMeta,
  isUserAbleToChat,
  pushNewMessage,
} from "../../redux-toolkit/slices/chatSlice";
import { socket } from "../../socketService";
import { IconMessageCircle, IconBell } from "@tabler/icons-react";
const TopNav: React.FC = () => {
  const dispatch = useAppDispatch();
  const userProfile = useSelector((state: RootState) => state.auth.userProfile);
  const { meta } = useSelector((state: RootState) => state.chat);
  const [unreadCount, setUnreadCount] = useState(0);
  const [userDropdownOpen, setUserDropdownOpen] = useState<boolean>(false);
  const navigate = useNavigate();
  
  useEffect(() => {
    const unreadCount = meta?.unreadCountForUser || 0;
    setUnreadCount(unreadCount);
  }, [meta]);
  
  const toggleUserDropdown = () => {
    setUserDropdownOpen(!userDropdownOpen);
  };
  
  useEffect(() => {
    dispatch(getMyProfile());
    dispatch(getMetaChatMeta());
    dispatch(isUserAbleToChat());
  }, []);
  
  useEffect(() => {
    socket.on("messageFromAdmin", (message) => {
      dispatch(
        pushNewMessage({
          _id: Math.random(),
          ...message,
          receiverId: userProfile?.id,
          isRead: false,
          updatedAt: message.createdAt,
        })
      );
    });
  }, []);
  
  useEffect(() => {
    if (userProfile) {
      socket.emit(
        "join",
        {
          userId: userProfile.id,
          client: "web",
        },
        () => {}
      );
    }
  }, [userProfile]);
  return (
    <>
      {/* Message/Chat Icon */}
      <button 
        className="navbar-icon-btn" 
        onClick={() => navigate('/chat')}
        aria-label="Messages"
      >
        <IconMessageCircle size={20} />
        {unreadCount > 0 && (
          <span className="navbar-notification-badge">{unreadCount}</span>
        )}
      </button>

      {/* Notifications Icon */}
      <button 
        className="navbar-icon-btn" 
        aria-label="Notifications"
      >
        <IconBell size={20} />
        <span className="navbar-notification-badge">2</span>
      </button>

      {/* User Avatar */}
      {userProfile && (
        <div className="navbar-user-avatar" onClick={toggleUserDropdown}>
          <span>
            {userProfile.firstName?.[0]}{userProfile.lastName?.[0]}
          </span>
          
          {/* User Dropdown Menu */}
          <div className={`navbar-user-dropdown ${userDropdownOpen ? 'open' : ''}`}>
            <a 
              href="#" 
              className="navbar-user-dropdown-item"
              onClick={(e) => {
                e.preventDefault();
                navigate('/auth/account-settings');
                setUserDropdownOpen(false);
              }}
            >
              Account Settings
            </a>
            <a 
              href="#" 
              className="navbar-user-dropdown-item logout"
              onClick={(e) => {
                e.preventDefault();
                localStorage.clear();
                window.location.href = "/";
              }}
            >
              Logout
            </a>
          </div>
        </div>
      )}
    </>
  );
};
export default TopNav;
